import Button from './button';
import translate from '../functions/translate';

interface OkButtonProps {
    onClick: () => void
}

const OkButton = (props: OkButtonProps) => {

    return <>
        <Button
            variation={'solid'}
            mfaAnalyticsData={{
                text: translate('ok'),
                parentComponentHeading: translate('create_an_account')
            }}
            onClick={props.onClick}
        >
            {translate('ok')}
        </Button>
    </>;
}

export default OkButton;
